/**
 * Environment utilities for standardized access to environment variables
 */

// API Keys
// OPENAI_API_KEY removed 2026-05-09 — backend proxies all OpenAI calls; keeping it
// would re-expose the secret in the production JS bundle.
export const ELEVENLABS_API_KEY = import.meta.env.VITE_ELEVENLABS_API_KEY || '';
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';
export const GOOGLE_SEARCH_ENGINE_API_KEY = import.meta.env.VITE_GOOGLE_SEARCH_ENGINE_API_KEY || '';
export const GOOGLE_SEARCH_ENGINE_ID = import.meta.env.VITE_GOOGLE_SEARCH_ENGINE_ID || '';

// Resource Identifiers
export const SPLINE_SCENE_URL = import.meta.env.VITE_SPLINE_SCENE_URL || 'https://prod.spline.design/ToDKyzaieC07te7t/scene.splinecode';
export const MAP_ID = import.meta.env.VITE_MAP_ID || '';

// App Configuration
export const ENV = import.meta.env.VITE_ENV || 'local';
export const AUTH_SERVER_URL = import.meta.env.VITE_AUTH_SERVER_URL || 'http://localhost:8880/';
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api';
export const WEBSOCKET_PROTOCOL = import.meta.env.VITE_WEBSOCKET_PROTOCOL || 'ws';
export const HTTP_TIMEOUT_MILLIS = Number(import.meta.env.VITE_HTTP_TIMEOUT_MILLIS || 600000); // 10 minutes default
export const DOMAIN = import.meta.env.VITE_DOMAIN || 'local.slingshot.qa.nnncapital.cloud';
export const SENTRY_ENABLED = import.meta.env.VITE_SENTRY_ENABLED === 'true';
export const USE_GOOGLE_SEARCH = import.meta.env.VITE_USE_GOOGLE_SEARCH === 'true';

/**
 * Helper function to access environment variables dynamically
 * Primarily used for migration from old config system
 */
export const getEnv = (key: string): string | boolean | number | undefined => {
  switch (key) {
    // API Keys
    case 'ELEVENLABS_API_KEY': return ELEVENLABS_API_KEY;
    case 'GOOGLE_MAPS_API_KEY': return GOOGLE_MAPS_API_KEY;
    case 'GOOGLE_SEARCH_ENGINE_API_KEY': return GOOGLE_SEARCH_ENGINE_API_KEY;
    case 'GOOGLE_SEARCH_ENGINE_ID': return GOOGLE_SEARCH_ENGINE_ID;
    
    // Resource Identifiers
    case 'SPLINE_SCENE_URL': return SPLINE_SCENE_URL;
    case 'MAP_ID': return MAP_ID;
    
    // App Configuration
    case 'ENV': return ENV;
    case 'AUTH_SERVER_URL': return AUTH_SERVER_URL;
    case 'API_BASE_URL': return API_BASE_URL;
    case 'WEBSOCKET_PROTOCOL': return WEBSOCKET_PROTOCOL;
    case 'HTTP_TIMEOUT_MILLIS': return HTTP_TIMEOUT_MILLIS;
    case 'DOMAIN': return DOMAIN;
    case 'SENTRY_ENABLED': return SENTRY_ENABLED;
    case 'USE_GOOGLE_SEARCH': return USE_GOOGLE_SEARCH;
    
    default:
      console.warn(`Unknown environment variable: ${key}`);
      return undefined;
  }
}; 